import { HTTP } from '..'

const apiGetRecordUsers = (folio) => {
  return new Promise((resolve, reject) => {
    console.log("Folio in URL: "+folio)
    HTTP
        .get('records/' + folio)
          .then((response) => {
              resolve(response)
          })
          .catch((error) => {
              reject(error)
          })
  })
}

const apiGetRecordSocialServiceUsers = (folio) => {
  return new Promise((resolve, reject) => {
    console.log("Folio in URL: "+folio)
    HTTP
        .get('records_social_service/' + folio)
          .then((response) => {
            resolve(response)
          })
          .catch((error) => {
            reject(error)
          })
  })
}

const apiGetRecordLanguageReleaseUsers = (folio) => {
  return new Promise((resolve, reject) => {
    console.log("Folio in URL: "+folio)
    HTTP
        .get('records_language_release/' + folio)
          .then((response) => {
            resolve(response)
          })
          .catch((error) => {
            reject(error)
          })
  })
}

const apiGetRecordExchangeValidationUsers = (folio) => {
  return new Promise((resolve, reject) => {
    console.log("Folio in URL: "+folio)
    HTTP
        .get('records_exchange_validation/' + folio)
          .then((response) => {
            resolve(response)
          })
          .catch((error) => {
            reject(error)
          })
  })
}

const apiGetDigitalDegreeUsers = (folio) => {
  return new Promise((resolve, reject) => {
    console.log("Folio in URL: "+folio)
    HTTP
        .get('digital_degree/' + folio)
          .then((response) => {
            resolve(response)
          })
          .catch((error) => {
            reject(error)
          })
  })
}

export { apiGetRecordUsers, apiGetRecordSocialServiceUsers, apiGetRecordLanguageReleaseUsers, apiGetRecordExchangeValidationUsers, apiGetDigitalDegreeUsers }